import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'

const NewMerchantForm = function ({ currencies }) {

	const SelectOptions = function () {
		let options = [(<option key='' value=''>Select Currency</option>)]
		for (let i = 0; i < currencies.length; i++) {
			const content = currencies[i]
			options.push(<option key={content.id} value={content.id}>{content.abbreviation.concat(' - ').concat(content.name)}</option>)
		}
		return options
	}

	return (
		<>
			<Row className="mb-3">
				<Form.Group as={Col}>
					<Form.Label htmlFor="merchantName">Name</Form.Label>
					<Form.Control id="merchantName" name="name" maxLength="50" required />
					<Form.Control.Feedback type="invalid">Name is required.</Form.Control.Feedback>
				</Form.Group>
			</Row>
			<Row className="mb-3">
				<Form.Group as={Col}>
					<Form.Label htmlFor="currencyCode">Currency</Form.Label>
					<Form.Select
						id="currencyCode"
						name="currencyCode"
						required
						defaultValue=""
					>
						<SelectOptions></SelectOptions>
					</Form.Select>
					<Form.Control.Feedback type="invalid">Currency is required.</Form.Control.Feedback>
				</Form.Group>
			</Row>
		</>
	)
}
export default NewMerchantForm
